import { forwardRef } from 'react';
import { Sidebar } from 'primereact/sidebar';
import useReducedMotion from './useReducedMotion';
import './overlayMotion.css';

const AnimatedSheet = forwardRef(function AnimatedSheet({ className = '', transitionOptions, onExited, ...props }, ref) {
    const reduced = useReducedMotion();
    return <Sidebar ref={ref} {...props} className={`akello-overlay-sheet ${className}`} transitionOptions={{
        appear: true,
        classNames: {
            appear: 'p-sidebar-enter', appearActive: 'p-sidebar-enter-active', appearDone: 'p-sidebar-enter-done',
            enter: 'p-sidebar-enter', enterActive: 'p-sidebar-enter-active', enterDone: 'p-sidebar-enter-done',
            exit: 'p-sidebar-exit', exitActive: 'p-sidebar-exit-active', exitDone: 'p-sidebar-exit-done',
        },
        ...transitionOptions,
        timeout: reduced ? 0 : { enter: 260, exit: 220 },
        onExited: (...args) => { transitionOptions?.onExited?.(...args); onExited?.(...args); },
    }} />;
});

export default AnimatedSheet;
